'use strict';

export class SignUp {

	constructor() {
		const word_quantity = document.querySelector(".form-group span.word-quantity")
		const textarea_to_evaluate = document.querySelector(".form-group textarea[name=message_about_campaign]")
		if(!word_quantity || !textarea_to_evaluate) return

		textarea_to_evaluate.addEventListener('input', e => {
			word_quantity.innerText = e.target.value === '' ?
				'0 / ' + e.target.maxLength:
				e.target.value.trim().split(' ').length + ' / ' + e.target.maxLength
		})
	}

}
